import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var SomePipe = (function () {
    function SomePipe() {
    }
    SomePipe.prototype.transform = function (input, predicate) {
        if (!isArray(input) || !predicate) {
            return input;
        }
        var result = false;
        var i = -1;
        while (++i < input.length && !result) {
            result = predicate(input[i], i, input);
        }
        return result;
    };
    return SomePipe;
}());
export { SomePipe };
SomePipe.decorators = [
    { type: Pipe, args: [{
                name: 'some'
            },] },
];
/** @nocollapse */
SomePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=some.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/some.pipe.js
// module id = 247
// module chunks = 103